import {
  boolean,
  ConfigSchema,
  InferConfigType,
  OmicronConfigResponseType,
  string,
  stringMap,
  WithTypeCheck,
} from '@utils/omicron';

export const OmicronConfigSchema = {
  QR_REDIRECTS: stringMap(),
  WEB_AUTO_DOWNLOAD: boolean(),
  WEB_SHOW_MINIPICKS: boolean(),
  WEB_SHOW_SEARCH: boolean(),
  WEB_SHOW_BEELINE: boolean(),
  WEB_SHOW_DVIJENIE_PERVIKH: boolean(),
  WEB_BEELINE_OFFER: string(),
  WEB_DVIJENIE_PERVIH_OFFER: string(),
  WEB_SHOW_RUSTORE_OPEN: boolean(),
  WEB_SHOW_PROSTORE_PAGE: boolean(),
  WEB_SHOW_AURORA_PAGE: boolean(),
  WEB_SHOW_REDESIGN: boolean(),
  WEB_SHOW_KIDS_PAGE: boolean(),
  WEB_SHOW_INSTRUCTION_REDESIGN: boolean(),
  WEB_SHOW_AUTOUPDATE_PAGE: boolean(),
  WEB_SHOW_CAREER_PAGE: boolean(),
  WEB_SHOW_LOCALIZATION: boolean(),
} satisfies ConfigSchema;

export type OmicronConfigType = InferConfigType<
  WithTypeCheck<typeof OmicronConfigSchema>
>;

export type OmicronResponse = OmicronConfigResponseType<OmicronConfigType>;
